import React from 'react';
import { motion } from 'framer-motion';
import { BuyButton } from './BuyButton';
export function Hero() {
  return <section className="relative w-full overflow-hidden bg-cream pt-32 pb-20 md:pt-40 md:pb-28" data-id="element-70" data-mp="eiv62y7sfcld">
      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-14 px-6 md:grid-cols-2 md:px-10" data-id="element-71" data-mp="9luz8l3465t7">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} data-id="element-72" data-mp="4n1k6o86i6qx">
          <p className="mb-6 font-sans text-xs uppercase tracking-[0.3em] text-muted" data-id="element-73" data-mp="sai535t46z7u">
            Nuevo ebook · Descarga inmediata
          </p>
          <h1 className="font-serif text-6xl leading-[0.95] text-ink md:text-7xl" data-id="element-74" data-mp="nbydaoruat7k">
            Basta de
            <br data-id="element-75" data-mp="3czfme2gnud7m" />
            sostenerlo
            <br data-id="element-76" data-mp="381xlmzcsr4ap" />
            <em className="italic text-sage" data-id="element-77" data-mp="381e0l9runzsg">todo.</em>
          </h1>
          <p className="mt-8 max-w-md font-sans text-base leading-relaxed text-ink-soft" data-id="element-78" data-mp="3j8sfs1yzrlqd">
            Una guía para soltar la exigencia sin culpa y encontrarte de nuevo.
            9 capítulos breves, un ejercicio por capítulo, y 3 bonos para
            aplicar desde el primer día.
          </p>
          <div className="mt-10 flex flex-wrap items-center gap-5" data-id="element-79" data-mp="3e960zo3ilxfg">
            <BuyButton variant="solid" size="lg" data-id="element-80" data-mp="3ebir4ojffe3l">
              Quiero mi copia
            </BuyButton>
            <span className="font-sans text-sm text-muted" data-id="element-81" data-mp="30g6lhm3qg37w">
              Pago único · Garantía de 7 días
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.15
      }} className="flex justify-center" data-id="element-82" data-mp="2ql69un2ak50c">
          <div className="w-full max-w-md bg-cream-deep p-6 shadow-[0_30px_60px_-30px_rgba(51,50,31,0.35)] md:p-10" data-id="element-83" data-mp="s21kmih80q35">
            <img src="https://cdn.magicpatterns.com/uploads/df5NofHsh2ti1ymX2b3HBo/Logo_RT_(1).png" alt="Portada del ebook Basta de sostenerlo todo" className="mx-auto w-full max-w-xs object-contain drop-shadow-2xl" data-id="element-84" data-mp="nat7bbcrskkp" />
          </div>
        </motion.div>
      </div>
    </section>;
}